// removed by extract-text-webpack-plugin
module.exports = {"primary1Color":"rgb(42, 56, 144)","primary2Color":"rgb(60, 92, 170)","primary3Color":"rgb(0, 0, 0)","accent1Color":"rgb(46, 125, 192)","accent2Color":"rgb(120, 182, 227)","accent3Color":"rgb(192, 200, 202)","xs":"576px","sm":"768px","md":"1024px","lg":"1200px","paperBoxShadow":"0 1rem 3rem rgba(0, 0, 0, 0.1)"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Treatments/style.css
// module id = 648
// module chunks = 0